var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-row" }, [
    _c("div", { staticClass: "form-group col-12" }, [
      _c("p", { staticClass: "font-weight-bold" }, [_vm._v("Select Sound")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "models-wrapper" },
        _vm._l(_vm.media, function(sound, key) {
          return _c("div", { key: key, staticClass: "model-item" }, [
            _c("div", { staticClass: "col-1" }, [
              sound.hasOwnProperty("showStopButton") && !sound.showStopButton
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-success",
                      attrs: { id: "select_audio_duration_s" },
                      on: {
                        click: function($event) {
                          return _vm.playSound(key)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-play" })]
                  )
                : _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-danger",
                      attrs: { id: "select_audio_duration_e" },
                      on: {
                        click: function($event) {
                          return _vm.stopSound(key)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-stop" })]
                  )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-1" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  on: {
                    click: function($event) {
                      return _vm.changeSelectedModel(key, sound)
                    }
                  }
                },
                [_vm._v("\n              Select\n            ")]
              )
            ]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(sound.name))])
          ])
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-94cff0ba", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94cff0ba","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/story-edit-view/timeline-components/sounds.vue
// module id = null
// module chunks = 